import { Module } from 'vuex'
import axios from '@/plugins/axios'

const rewardModule: Module<any, any> = {
    actions: {
        async GetRewards({ commit, rootState }, { page, perPage }) {
            let data = null

            const headers = {
                Authorization: 'Bearer ' + rootState.auth.token,
            }

            await axios
                .get('/api/rewards?page=' + page + '&itemPerPage=' + perPage, {
                    headers: headers,
                })
                .then((response) => {
                    data = response.data
                })

            return data
        },
    },
}

export default rewardModule
